import React from "react";
import { createRoot } from "react-dom/client";

import store from "./redux/store";
import { Provider } from "react-redux";

import ProductsCountContainer from "./containers/products_count";
import ProductsRootContainer from "./containers/products_root";
import FiltersContainer from "./containers/filters";
import DownloadMaterialsContainer from "./containers/download_materials";
import PreviewProductsContainer from "./containers/preview_products";
import GenerateEntriesContainer from "./containers/generate_entries";
import BasketContainer from "./containers/basket";
import ViewModeSwitcherContainer from "./containers/view_mode_switcher";
import DownloadNotificationContainer from "./containers/download_notification";
import ThreeViewContainer from "./containers/three_view";
import { initialDataLoaded } from "./redux/default/reducer";
import { initialDisplayModelLoaded } from "./redux/common/reducer";

import "react-select/dist/react-select.css";
import 'react-block-ui/style.css';

import "./styles/app.scss";
import "./styles/products.scss";
import "./styles/products_count.scss";
import "./styles/basket.scss";
import "./styles/view_mode_switcher.scss";
import "./styles/download_materials.scss";
import "./styles/filters.scss";
import "./styles/generate_entries.scss";
import "./styles/preview_products.scss";
import "./styles/products_root.scss";

const renderComponent = (component, container) => {
  if (container) {
    const root = createRoot(container);

    root.render(
      <Provider store={store}>
        {component}
      </Provider>
    );
  }
};

export const init = () => {
  const node = document.querySelector('[data-app="products"]');
  const initialData = JSON.parse(node.getAttribute("data-json"));
  store.dispatch(initialDataLoaded(initialData));
  store.dispatch(initialDisplayModelLoaded(initialData));
  const { displayMode } = store.getState().common;

  renderComponent(displayMode === "default" ? <ProductsRootContainer /> : <ThreeViewContainer />, node);
  renderComponent(<ProductsCountContainer />, document.querySelector('[data-component="products-count"]'));
  renderComponent(<FiltersContainer />, document.querySelector('[data-component="filters"]'));
  renderComponent(<DownloadMaterialsContainer />, document.querySelector('[data-component="download-materials"]'));
  renderComponent(<PreviewProductsContainer />, document.querySelector('[data-component="preview-products"]'));
  renderComponent(<GenerateEntriesContainer />, document.querySelector('[data-component="generate-entries"]'));
  displayMode === 'default' && renderComponent(<BasketContainer />, document.querySelector('[data-component="basket"]'));
  displayMode === 'default' && renderComponent(<ViewModeSwitcherContainer />, document.querySelector('[data-component="view-mode-switcher"]'));
  renderComponent(<DownloadNotificationContainer />, document.querySelector('[data-component="download-notification"]'));
};